import { useNavigate } from "react-router-dom";
import { useSelectRealmMutation, useGetUserRealmsQuery } from "services/users"
import styled from "styled-components"


export type UserRealm = {
    id: string;
    name: string;
}


export const RealmSelector = () => {
    const { data: realmsData, isLoading: realmsLoading } = useGetUserRealmsQuery(undefined);
    const [selectRealm, { isLoading: selectingRealm }] = useSelectRealmMutation();
    const navigate = useNavigate();

    const handleRealmSelect = async (realmId: string) => {
        try {
            await selectRealm({ realm_id: realmId }).unwrap();
            navigate("/backoffice/");
        } catch (error) {
            console.error("Failed to select realm:", error);
        }
    }

    if (realmsLoading) {
        return <div>Loading realms...</div>;
    }
    console.log("Realms data:", realmsData);

    return (
        <Container>
            <h2>Select a Realm</h2>
            {realmsData && realmsData.length > 0 ? (
                <RealmList>
                    {realmsData.map((realm: any) => (
                        <RealmItem key={realm.id} onClick={() => handleRealmSelect(realm.id)}>
                            {realm.name}
                        </RealmItem>
                    ))}
                </RealmList>
            ) : (
                <div>No realms available.</div>
            )}
            {selectingRealm && <div>Selecting realm...</div>}
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const RealmList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
`;

const RealmItem = styled.div`
    padding: 10px 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f0f0f0;
    }
`;

